module.exports = __webpack_public_path__ + "media/images/illustrations/unit_sizes/10x50_small-0d6f8be986323e35433b3897ff813616.png";